import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { TableContainer, Paper, Theme, Tooltip } from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";
import StorageIcon from "@material-ui/icons/Storage";
import LanguageIcon from "@material-ui/icons/Language";
// import { LayoutConst } from "../../constants";
import { FileTypeIcon } from "../filetype/FileTypeIcon";
import { DocumentItemType } from "../../types";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // container: {
    //   minWidth: LayoutConst.table.minWidth.default,
    //   overflowY: "auto",
    //   minHeight: 300,
    //   height: "100%",
    // },
    virtualFolderContainer: {
      width: "100%",
      overflowY: "auto",
      minHeight: 300,
      height: "100%",
    },
    table: {
      borderCollapse: "collapse",
      margin: "0 auto",
      width: "100%",
    },
    tbody: {
      width: "100%",
    },
    tr: {
      width: "100%",
      cursor: "context-menu",
      marginTop: "0.75rem",
      boxSizing: "content-box",
    },
    tdNo: {
      width: "4%",
      textAlign: "center",
      verticalAlign: "top",
      padding: "0.4rem 0.5rem 0.25rem 0.5rem",
    },
    tdFilename: {
      width: "auto",
      // width: "60%",
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
      color: theme.palette.primary.dark,
      fontSize: "1rem",
      fontWeight: "bold",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      maxWidth: 0,
    },
    tdFileType: {
      width: 20,
      // width: "5%",
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
    },
    tdSourceType: {
      width: 20,
      // width: "5%",
      textAlign: "left",
      padding: "0.25rem 0.25rem 0.25rem 0.25rem",
      color: "rgba(0,0,0,0.87)",
    },
    tdUpdateDate: {
      width: 160,
      textAlign: "left",
      padding: "0.25rem 0.5rem 0.25rem 0.5rem",
      color: theme.palette.text.secondary,
    },
    iconSourceType: {
      fontSize: 16,
      marginTop: "0.2rem",
      marginRight: "0.3rem",
    },
  })
);

interface Props {
  rows: DocumentItemType[];
  currentPage?: number;
  displayCount?: number;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  contextMenu: JSX.Element;
}

/** 検索結果簡易表示 */
export function ContentSimpleTable(props: Props) {
  const classes = useStyles();

  //------------------------------
  // Result 検索結果
  // [State]
  const { rows } = props;

  //------------------------------
  // ページ情報
  // currentPage 現在ページ番号
  // displayCount 1ページの表示上限数
  // [State]
  const { currentPage } = props;
  const { displayCount } = props;

  //------------------------------
  // コンテキストメニュー
  // [State]
  const { contextMenu } = props;
  // [Handler]
  const { onClick } = props;

  //--------------------
  // コンポーネント
  return (
    <TableContainer
      className={classes.virtualFolderContainer}
      component={Paper}
    >
      <table className={classes.table}>
        <tbody className={classes.tbody}>
          {rows.map((row, i) => {
            const key = `${i}-${row.filename}`;
            return (
              <tr
                id={`data-${i}`}
                className={classes.tr}
                key={`${key}-1`}
                onContextMenu={onClick}
              >
                <td className={classes.tdNo}>
                  {currentPage && displayCount
                    ? (currentPage - 1) * displayCount + i + 1
                    : i + 1}
                </td>
                <td className={classes.tdFilename}>{row.filename}</td>
                <td className={classes.tdFileType}>
                  <Tooltip title={row.file_type} aria-label={row.file_type}>
                    <div>
                      <FileTypeIcon fileType={row.file_type} />
                      {/* {row.file_type} */}
                    </div>
                  </Tooltip>
                </td>
                <td className={classes.tdSourceType}>
                  {row.source_type === "NAS" ? (
                    <Tooltip title="ファイル" aria-label="ファイル">
                      <div>
                        <StorageIcon className={classes.iconSourceType} />
                        {/* <span style={{ verticalAlign: "top" }}>ファイル</span> */}
                      </div>
                    </Tooltip>
                  ) : (
                    <Tooltip title="ウェブ" aria-label="ウェブ">
                      <div>
                        <LanguageIcon className={classes.iconSourceType} />
                        {/* <span style={{ verticalAlign: "top" }}>ウェブ</span> */}
                      </div>
                    </Tooltip>
                  )}
                </td>
                <td className={classes.tdUpdateDate}>
                  <Tooltip title="更新日時" aria-label="更新日時">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <HistoryIcon
                        fontSize="small"
                        style={{
                          display: "inline-flex",
                          verticalAlign: "middle",
                          marginRight: "0.25rem",
                        }}
                      />
                      {row.update_date}
                    </div>
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {contextMenu}
    </TableContainer>
  );
}
